'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import classNames from '@/utils/classNames';
import Spinner from '@/components/Spinner';
import ButtonIcon from './ButtonIcon';
type LoadingPlaceholderProps = {
  className?: string;
  circular?: boolean;
  light?: boolean;
  children?: React.ReactNode;
};
const LoadingPlaceholder = t0 => {
  const $ = _c(12);
  const {
    className,
    circular,
    light,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("absolute top-0 left-0 inline-flex h-full w-full! cursor-progress items-center justify-center gap-x-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = light ? "dark" : "light";
  let t3;
  if ($[2] !== circular || $[3] !== t2) {
    t3 = <ButtonIcon as={Spinner} main={circular} theme={t2} />;
    $[2] = circular;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== circular) {
    t4 = !circular && <span className="truncate">{children}</span>;
    $[5] = children;
    $[6] = circular;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className={t1}>{t3}{t4}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default memo(LoadingPlaceholder);